import React, { useContext } from 'react';
import LanguageContext, { strings } from '../contexts/language';
import footerImg from '../assets/images/footer.png';
import devLogo from '../assets/images/nerdetcetera.png';

export default function Footer({ noImage }) {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;

    return (
        <footer className="footer">
            {!noImage && (
                <div className="footer-image">
                    <img src={footerImg} alt="III Fórum de Finanças Climáticas e de Natureza" />
                </div>
            )}
            <div className="footer-bottom">
                <div className="footer-bottom-inner">
                    <span className="footer-copy">{t.footer_rights}</span>
                    <span className="footer-dev">
                        Desenvolvido por{' '}
                        <a href="https://nerdetcetera.com" target="_blank" rel="noreferrer" className="footer-dev-link">
                            <img src={devLogo} alt="Nerd Etcetera" />
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
}
